import { createFileRoute } from '@tanstack/react-router'
import { configQuery } from '~/features/auth/queries'
import { RegisterPage } from '~/features/auth/RegisterPage'

export const Route = createFileRoute('/registrieren')({
  loader: ({ context }) => void context.queryClient.prefetchQuery(configQuery),
  component: RegisterPage,
})
